import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { Color, TreeItemVariants } from '@/types'
import type { NodeClasses } from '../../../../ArtBoard/Node'
import { Handler } from '../../../../ArtBoard/Node/components/Handler'
import { VARIANTS } from '../../../../ArtBoard/Node/constants'
import css from '../../../../ArtBoard/Node/Node.module.scss'
import { Blocks } from './Block'
import { PageContentViewName as Name } from './PageContentViewName'

type Props = {
  id: string
  name: string
  color: Color | string
  variant: TreeItemVariants
  blockId?: ID
}

export const Node: React.FC<Props> = ({
  color,
  variant,
  id,
  name,
  blockId,
}) => {
  const isProjectMobile = useSelector(
    migrationProjectSelector.getIsProjectMobile
  )

  const isProjectNeutral = useSelector(
    migrationProjectSelector.getIsProjectNeutral
  )

  const nodeStyles = {
    '--node-color': color,
  } as React.CSSProperties

  const nodeClasses: NodeClasses = {
    container: cx('Tree-node', css.container, css.map, {
      [css.mobile]: isProjectMobile,
    }),
    node: cx('Tree-node-inner', css.node, {
      'node--mobile': isProjectMobile,

      [css.mobile]: isProjectMobile,

      // variants
      [css.page]: variant === VARIANTS.DEFAULT,
      [css.dashed]: variant === VARIANTS.FRAME,
      [css.stack]: variant === VARIANTS.STACK,
    }),
    body: css.body,
    stackGhost: cx(css.stackGhost, 'stack-ghost'),
  }

  return (
    <div className={nodeClasses.container} style={nodeStyles}>
      {variant === VARIANTS.STACK && <div className={nodeClasses.stackGhost} />}
      <div className={nodeClasses.node}>
        <div>
          <div>
            {(variant === VARIANTS.DEFAULT || variant === VARIANTS.STACK) &&
              !isProjectNeutral && (
                <Handler canDrag={false} isSelected={false} variant={variant} />
              )}

            <Name name={name} variant={variant} />
          </div>

          <div className={nodeClasses.body}>
            <Blocks nodeId={id} blockId={blockId} />
          </div>
        </div>
      </div>
    </div>
  )
}
